import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = '/categories.php';

export function getCategories() {

    const response = api.get(service_path);

    return response;
};

export function getCategoryDetails(id) {
    return api.get(`${service_path}?id=${id}`);
}

export function createCategory(data, navigateBack) {

    api.post(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Categoria cadastrada com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function updateCategory(data, navigateBack) {

    api.patch(service_path, data)
        .then(response => {

            const { data } = response;

            if (data.success) {
                globalToast.success("Categoria editada com sucesso!");
                navigateBack();
            } else {
                globalToast.error(data.message);
            };
        })
        .catch(error => {
            console.log(error);
            globalToast.error('Houve um erro ao executar essa ação!');
        });
};

export function deleteCategory(id, user_id) {
    api.delete(service_path, { data: { id, user_id } })
        .then(response => {
            const { data } = response;

            if (data.success) {
                globalToast.success("Categoria deletada com sucesso!")
            } else {
                globalToast.error('Houve um erro ao deletar essa categoria!');
            };
        })
        .catch(error => {
            globalToast.error(error.response.data.message)
            console.log(error)
        });
};